import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { SimpleMatDataSource } from '../../common/providers/simple-mat-data-source';
import {
  FeedbackItemRightsList,
  FeedbackRights,
  mapFeedbackItemRightsToRowRights
} from '../../feedback/providers/feedback-rights';
import { FeedbackAthleteAnswerProvider } from '../../feedback/providers/feedback-athlete-answer-provider';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { UtilsProvider } from "../../common/providers/utils-provider.service";
import { CurrentUser } from "../../common/providers/current-user";
import { UsersProvider } from '../../users/providers/users-provider';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { CurrentUserRolesProvider } from '../../organizations/providers/current-user-roles-provider';
import { Title } from '@angular/platform-browser';
import { ConfigProvider } from "../../config-provider.service";
import { forkJoin, map, Observable, Subscription, switchMap } from 'rxjs';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Organization } from "../../common/models/organization";
import { Athlete } from "../../common/models/athlete";
import { User } from "../../common/models/user";
import { FeedbackAthleteAnswer } from "../../common/models/feedback-athlete-answer";
import { ConfirmDialogComponent } from "../../common/components/confirm-dialog/confirm-dialog";
import { ApiBaseService } from "../../common/providers/api-base-service";
import { MobileSideMenuComponent } from "../../common/components/mobile-side-menu/mobile.side-menu.component";
import { ModuleContentComponent } from "../../common/components/module-content/module-content";
import {
  FeedbackAthleteSmileyComponent
} from "../../feedback/components/athlete-smiley/feedback-athlete-smiley.component";
import { MobilePageContentComponent } from "../../common/components/mobile-page-content/mobile-page-content";
import { MobileHeaderComponent } from "../../common/components/mobile-header/mobile.header";
import { MatIcon, MatIconModule } from "@angular/material/icon";
import { MatMenu, MatMenuModule } from "@angular/material/menu";
import { MatFormField, MatFormFieldModule } from "@angular/material/form-field";
import { MatCell, MatHeaderCell, MatHeaderRow, MatRow, MatTable, MatTableModule } from "@angular/material/table";
import { MatInputModule } from "@angular/material/input";
import { NgIf } from "@angular/common";
import { MatSortModule } from "@angular/material/sort";
import { AppDatePipe } from "../../common/pipes/app-date";
import { MatIconButton } from "@angular/material/button";
import { FlexLayoutModule } from "@angular/flex-layout";
import { AthletesProvider } from "../../athletes/providers/athletes-provider";
import { CoachesProvider } from "../../coaches/providers/coaches-provider";
import { OrganizationsProvider } from "../../organizations/providers/organizations-provider";
import { OrganizationMembership } from "../../common/models/organization-membership";
import { AthleteCoach } from "../../common/models/athlete-coach";
import { OrganizationRole } from "../../common/models/organization-role";
import { OrganizationMembership_OrganizationRole } from "../../common/models/organization-membership_organization-role";
import { Paginator } from "../../common/models/paginator";
import { Coach } from "../../common/models/coach";
import { Feedback } from "../../common/models/feedback";

@Component({
  selector: 'app-mobile-feedback-list-container',
  templateUrl: './mobile.feedback-list-container.component.html',
  styleUrls: ['./mobile.feedback-list-container.scss'],
  imports: [
    MatPaginator,
    MobileSideMenuComponent,
    ModuleContentComponent,
    FeedbackAthleteSmileyComponent,
    MobilePageContentComponent,
    MobileHeaderComponent,
    MatIconModule,
    MatMenuModule,
    MatFormFieldModule,
    MatTableModule,
    MatInputModule,
    NgIf,
    MatSortModule,
    TranslateModule,
    RouterLink,
    AppDatePipe,
    MatIconButton,
    FlexLayoutModule,
  ],
  standalone: true
})
export class MobileFeedbackListContainerComponent implements OnInit, AfterViewInit, OnDestroy {

    public pageTitle = 'Feedback';
    public isLoading = true;
    public is401 = false;
    public is404 = false;

    public dataSource: SimpleMatDataSource = new SimpleMatDataSource([]);
    public columns: string[] = ['name', 'createDate', 'mood', 'action'];
    public moodIconClass = 'athlete-smiley-icon medium-smiley material-icons';

    public organization: Organization = {} as Organization;
    public athleteUser: User = {} as User;

    public paginatedResults: any;
    public pageSize: number = FeedbackAthleteAnswer.NUM_ITEMS;
    public currentPage = 0;
    public totalSize = 0;

    public rights: FeedbackRights = new FeedbackRights(this.utils);

    @ViewChild(MatPaginator, {static: false}) public paginator: MatPaginator | undefined;

    private subscriptions: Subscription[] = [];

    constructor(
        private feedbackAthleteAnswerProvider: FeedbackAthleteAnswerProvider,
        private route: ActivatedRoute,
        private translator: TranslateService,
        private dialog: MatDialog,
        private toaster: MatSnackBar,
        private utils: UtilsProvider,
        private currentUser: CurrentUser,
        private currentUserRoles: CurrentUserRolesProvider,
        private title: Title,
        public conf: ConfigProvider,
        private athletesProvider: AthletesProvider,
        private coachesProvider: CoachesProvider,

    ) {
    }

    public ngOnInit(): void {
        this.subscriptions.push(
            this.route.data.subscribe((data: any) => { // { organization: Organization; athlete: Athlete }

                this.organization = data.organization;
                this.athleteUser = data.athlete;

                this.loadPaginatedData().subscribe(() => {
                    this.rights.evaluateScreenRights({
                        rolesIds: this.currentUserRoles.getRolesIds(this.organization.id!)
                    });

                    if (!this.rights.LIST) {
                        this.is401 = true;
                    }

                    this.createPageTitle();
                    this.isLoading = false;
                });
            })
        );
    }

    public ngAfterViewInit(): void {
        this.dataSource.paginator = this.paginator!;
    }

    public ngOnDestroy(): void {
        this.subscriptions.forEach((subscription) => subscription.unsubscribe());
    }

    public loadPaginatedData(page = 0, query = ''): Observable<any> {
      return this.feedbackAthleteAnswerProvider.findAllByOrganizationAndAthletePaginated(this.organization, this.athleteUser.athlete!, page, query).pipe(
        map((paginator: Paginator) => {

          this.paginatedResults = paginator;
          this.currentPage = this.paginatedResults.current_page - 1;
          this.pageSize = this.paginatedResults.per_page;
          this.totalSize = this.paginatedResults.total;

          if (this.paginatedResults.data) {
            this.paginatedResults.data.forEach((row: any) => {
              this.rights.setItemRightsList(row);
              row.rights = this.rights.getItemRightsList();
            });
          }

          this.dataSource.replaceAllWith(this.paginatedResults.data);
        })
      );
    }


    /**
     * Perform a new request for the requested page
     *
     * @param event
     */
    public onPaginateChange(event: PageEvent) {
        this.loadPaginatedData(event.pageIndex + 1).subscribe();
    }

    public onFilterKeyup(filter: string): void {
        this.loadPaginatedData(0, filter).subscribe();
    }

    public onDeleteClicked(row: any) {
        const dialog: MatDialogRef<ConfirmDialogComponent> = this.dialog.open(ConfirmDialogComponent, {
            data: {
                confirmText: 'FeedbackConfirmDelete',
                confirmActionText: 'Delete',
                confirmColor: 'primary'
            }
        });
        this.subscriptions.push(
            dialog.afterClosed().subscribe((confirmed: boolean) => {
                if (confirmed) {
                    this.subscriptions.push(
                        this.feedbackAthleteAnswerProvider.deleteById(this.organization, row.id).subscribe({
                            next: () => {
                                this.toaster.open(this.translator.instant('Feedback_Deleted'), '', {duration: 5000});
                                this.loadPaginatedData(this.currentPage + 1).subscribe();
                            },
                            error: (err: any) => {
                                this.toaster.open(err.error.message, '', { duration: 5000 });
                            },
                        })
                    );
                }
            })
        );
    }

    private createPageTitle() {
        this.pageTitle = this.translator.instant('Feedback_list');
        this.title.setTitle(this.pageTitle + ' | ' + this.conf.platformName);
    }
}
